import React, { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { RiChat3Line, RiLineChartLine } from "@remixicon/react";
import PageHeader from "../common/PageHeader";
import LinkList from "../common/LinkList";
import { sendHelpRequest, sendFeedback } from "../../api/common";

const HELP_LINKS = [
	{ to: "/messages", icon: RiChat3Line, label: "Messages", text: "Chat with sellers and the Ordr team" },
	{ to: "/market-updates", icon: RiLineChartLine, label: "Market updates", text: "Fuel news and crude price trends" },
];

export default function Help() {
	const user = useSelector((s) => s.auth.user);
	const [helpMessage, setHelpMessage] = useState("");
	const [feedbackMessage, setFeedbackMessage] = useState("");
	const [rating, setRating] = useState(5);
	const [submittingHelp, setSubmittingHelp] = useState(false);
	const [submittingFeedback, setSubmittingFeedback] = useState(false);

	const submitHelp = async () => {
		if (!helpMessage.trim()) {
			toast.error("Describe your issue first");
			return;
		}
		setSubmittingHelp(true);
		const res = await sendHelpRequest({ userId: String(user?.id || user?._id || ""), question: helpMessage.trim() });
		setSubmittingHelp(false);
		if (res && !res.error) {
			toast.success("Request submitted. Our team will reach out soon.");
			setHelpMessage("");
		} else {
			toast.error(res?.msg || "Could not submit request");
		}
	};

	const submitFeedback = async () => {
		if (!feedbackMessage.trim()) {
			toast.error("Write your feedback first");
			return;
		}
		setSubmittingFeedback(true);
		const res = await sendFeedback({ userId: String(user?.id || user?._id || ""), message: feedbackMessage.trim(), ratting: rating });
		setSubmittingFeedback(false);
		if (res && !res.error) {
			toast.success("Thanks for your feedback!");
			setFeedbackMessage("");
		} else {
			toast.error(res?.msg || "Could not submit feedback");
		}
	};

	return (
		<div>
			<PageHeader title="Help" subtitle="Get support, send feedback or message us" />
			<div className="mb-3" style={{ maxWidth: 720 }}>
				<LinkList items={HELP_LINKS} />
			</div>
			<div className="row g-3">
				<div className="col-lg-6">
					<div className="card p-4 h-100">
						<h6 className="fw-bold mb-3">Get Help</h6>
						<textarea className="form-control mb-3" rows={5} placeholder="Describe the issue you're facing" value={helpMessage} onChange={(e) => setHelpMessage(e.target.value)} />
						<button className="btn-accent-solid" style={{ width: 180 }} disabled={submittingHelp} onClick={submitHelp}>
							{submittingHelp ? "Sending..." : "Submit Request"}
						</button>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="card p-4 h-100">
						<h6 className="fw-bold mb-3">Send Feedback</h6>
						<div className="mb-3 d-flex gap-1">
							{[1, 2, 3, 4, 5].map((n) => (
								<button
									key={n}
									type="button"
									className="btn btn-sm"
									style={{ background: n <= rating ? "var(--color-accent)" : "#f2f2f2", border: "none", borderRadius: 6, width: 34 }}
									onClick={() => setRating(n)}
								>
									{n}
								</button>
							))}
						</div>
						<textarea className="form-control mb-3" rows={4} placeholder="What can we improve?" value={feedbackMessage} onChange={(e) => setFeedbackMessage(e.target.value)} />
						<button className="btn-accent-solid" style={{ width: 180 }} disabled={submittingFeedback} onClick={submitFeedback}>
							{submittingFeedback ? "Sending..." : "Send Feedback"}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
